import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Scenario from "../components/scenario/Scenario";
import SelectEquipmentModal from "../components/modals/SelectEquipmentModal";
import SelectOutputEquipment from "../components/modals/SelectOutputEquipment";

const ScenarioPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "سناریو",
      slug: "planning/scenario",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          <Scenario />
          
        </div>
    </HelmetProvider>
  );
};

export default ScenarioPage;
